import {get,post} from "./server";
import {Message} from 'element-ui'
import {delCookie} from "../assets/js/utils";

export default {
    namespaced: true,
    state: {
        userInfo: {},
        orgInfo: {}
    },
    mutations: {
        SET_USERINFO (state, userInfo) {
            state.userInfo = userInfo
        },
        SET_ORGINFO (state, orgInfo) {
            state.orgInfo = orgInfo
        }
    },
    actions: {
        async GetCurrUserInfo ({ commit, dispatch }) {
            const res = await get(`${process.env.VUE_APP_USER_HOST}/account/user/getMe`)
            if (res.code === 1000) {
                if (res.data.orgId) {
                    await dispatch('GetOrgInfo', {
                        orgId: res.data.orgId
                    })
                } else {
                    commit('SET_ORGINFO', {})
                }
                commit('SET_USERINFO', res.data)
            } else {
                Message.error('用户信息获取失败')
            }
        },
        async GetOrgInfo({ commit }, params) {
            const res = await get(`${process.env.VUE_APP_MAIN_HOST}/core/organization/getOrganizationInfo`,params)

            if (res.code === 1000) {
                commit('SET_ORGINFO', res.data)
            } else {
                Message.error('企业信息获取失败')
            }
        },
        async ExitUser({ commit }) {
            commit('SET_USERINFO', {})
            commit('SET_ORGINFO', {})
            await post(`${process.env.VUE_APP_USER_HOST}/account/user/logoutWeb`)
            window.sessionStorage.setItem('Authorization', '')
            delCookie('Authorization')
        },
        async GetMyOrganizations () {
          const res = await get(`${process.env.VUE_APP_MAIN_HOST}/core/organization/getMyOrganizations`)
          return res
        },
        async ChangeMember ({ dispatch }, data) {
          const res = await post(`${process.env.VUE_APP_MAIN_HOST}/core/member/ChangeMember`, data)
          if (res.code !== 1000) {
            return res
          }
          try {
            await dispatch('GetCurrUserInfo')
            return {
              code: 1000
            }
          } catch(e) {
            return {}
          }
        },
        async GetAuthInfo(c, { orgId }) {
          const res = await get(`${process.env.VUE_APP_MAIN_HOST}/core/organization/GetOrgOcrApprovalInfo?orgId=${orgId}`)
          return res
        }
    }

}
